//
// IMPORTS
//
import PropTypes from 'prop-types'

import React from 'react'
import classnames from 'classnames'

//
// COMPONENT
//
const PageSection = ({
  beforeSection,
  children,
  extraClass,
  first,
  isTriangleCutoff,
  triangleClass,
  quilt
}) => {
  const classes = classnames(
    {
      'page-section--first': first,
      'page-section--quilt': quilt
    },
    'page-section',
    extraClass
  )
  return (
    <section className={classes}>
      <div className='page-section__inner'>
        {beforeSection && (
          <div className='page-section__between-sections'>{beforeSection}</div>
        )}
        {children}
      </div>
      {isTriangleCutoff && (
        <div
          className={classnames(
            {
              [triangleClass]: !!triangleClass,
              // default
              'bg-white': !triangleClass
            },
            'page-section__triangle-cutoff'
          )}
        />
      )}
    </section>
  )
}

PageSection.propTypes = {
  beforeSection: PropTypes.node,
  children: PropTypes.node.isRequired,
  extraClass: PropTypes.string,
  first: PropTypes.bool,
  quilt: PropTypes.bool
}

//
// EXPORT
//
export default PageSection



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/PageSection.js